import {useGetHingeStylesQuery} from 'components/customer/Product/store/productApi';

export const useGetHingeStyle = (cabinetType: number) => {
    return useGetHingeStylesQuery(
        {
            cabinetType,
        },
        {
            skip: typeof cabinetType === 'undefined',
        }
    );
};
